import React from 'react'

export default function TrailSeparator () {
  return <span className='separator'>&raquo;</span>
}
